<script setup lang="ts">
const { marketplaces } = defineProps<{
    marketplaces?: {
        link: string;
        provider: string;
    }[]
}>();

const isMarketplacesVisible = ref(false);
const visibleMarketplaces = computed(() => marketplaces?.slice(0, 4) ?? []);

function showMarketplaces() {
    isMarketplacesVisible.value = true;
}

function hideMarketplaces() {
    isMarketplacesVisible.value = false;
}
</script>
<template>
    <div
    v-if="marketplaces?.length"
        class="inline-flex w-60 min-h-12"
        @mouseenter="showMarketplaces"
        @mouseleave="hideMarketplaces"
    >
        <Transition
            mode="out-in"
            enter-active-class="transition duration-200 ease-out"
            enter-from-class="scale-95 opacity-0"
            enter-to-class="scale-100 opacity-100"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="scale-100 opacity-100"
            leave-to-class="scale-95 opacity-0"
        >
            <UiButton
                v-if="!isMarketplacesVisible"
                key="trigger"
                variant="outline"
                class="w-full border-black!"
                aria-label="Показать маркетплейсы"
                @click="showMarketplaces"
            >
                Купить на сайте партнера
            </UiButton>

            <div
                v-else
                key="marketplaces"
                class="flex w-full items-center justify-start gap-3 rounded-lg bg-white"
                aria-label="Маркетплейсы"
            >
                <NuxtLink
                    v-for="item of visibleMarketplaces"
                    :key="item.provider + item.link"
                    :to="item.link"
                    target="_blank"
                    class="flex items-center justify-center transition-transform hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                    :title="item.provider"
                    :aria-label="`Купить на ${item.provider}`"
                >
                    <SvgoOzon
                        v-if="item.provider === 'Ozon'"
                        class="text-5xl"
                        filled
                    />
                    <SvgoWildberries
                        v-else-if="item.provider === 'WB'"
                        class="text-5xl"
                        filled
                    />
                    <SvgoLamoda
                        v-else-if="item.provider === 'Lamoda'"
                        class="text-5xl"
                        filled
                    />
                    <SvgoYandexMarket
                        v-else-if="item.provider === 'Яндекс Маркет'"
                        class="text-5xl"
                        filled
                    />
                </NuxtLink>
            </div>
        </Transition>
    </div>
</template>
